import React, { useEffect, useState, useRef } from "react";
import {
  Page,
  View,
  Document,
  StyleSheet,
  Image,
  PDFViewer,
  Stop,
  Rect,
  Svg,
  Defs,
  Text,
  Font,
  LinearGradient,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import { API_URL } from "../../shared/constant";
import { useLocation } from "react-router-dom";
import InputColor from "react-input-color";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { toast } from "react-toastify";
import axios from "axios";
import HorizontalProduct from "../../components/horizonal-product";
import VerticalProduct from "../../components/vertical-product";
import Loader from "../../shared/loader";

Font.register({
  family: "UniversoBold",
  src: "/../../assets/fonts/UniversoBold.ttf",
});
Font.register({
  family: "NexaLight",
  src: "/../../assets/fonts/NexaLight.otf",
});
Font.register({
  family: "NexaBold",
  src: "/../../assets/fonts/NexaBold.otf",
});

const PdfView = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const ids = query.get("ids");
  const fileInputRef = useRef(null);
  const [productIds, setProductIds] = useState([]);
  const [products, setProducts] = useState([]);
  const [withoutlogo, setWithoutLogo] = useState(false);
  const [layoutType, setLayoutType] = useState("");
  const [userId, setUserId] = useState(null);
  const [bgColor, setBgColor] = useState("#000000");
  const [bgColorTwo, setBgColorTwo] = useState("#eeeeee");
  const [fontColor, setFontColor] = useState("#ffffff");
  const [previewColor, setPreviewColor] = useState("#ffffff");
  const [withoutlogoBasd64, setWithoutLogoBasd64] = useState("");
  const [fileName, setFileName] = useState("");
  const [userLogo, setUserLogo] = useState("LOGO");
  const [usersLogo, setUsersLogo] = useState("");
  const [pageSize, setPageSize] = useState(595);
  const [isAllowed, setIsAllowed] = useState(false);
  const iframeRef = useRef(null);
  const [isIFrameLoaded, setIsIFrameLoaded] = useState(false);
  const iframeCurrent = iframeRef.current;

  const styles = StyleSheet.create({
    imageContainer: {
      position: "relative",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      marginBottom: 0,
      height: "100%",
      maxHeight: 842,
      width: "100%",
    },
    image: {
      width: "100%",
      height: pageSize - 50,
      maxHeight: 792,
    },
    rightlogo: {
      maxWidth: 150,
      maxHeight: 50,
    },
    leftlogo: {
      maxWidth: 150,
      maxHeight: 50,
    },
    centerlogo: {
      maxWidth: 150,
      maxHeight: 50,
    },
    previewname: {
      display: "flex",
      flexDirection: "column",
      position: "absolute",
      fontSize: 20,
      bottom: 60,
      left: 60,
      color: previewColor,
    },
    previewsize: {
      fontSize: 16,
      color: previewColor,
    },
    previewBoxDetail: {
      display: "flex",
      flexDirection: "column",
    },
    previewSizeBox: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
    },
    previewImage: {
      padding: 20,
      position: "relative",
    },
  });

  const fetchProducts = async () => {
    try {
      const response = await axios.post(API_URL.PRODUCT_BY_IDS, {
        product_ids: productIds,
        without_logo: withoutlogo,
      });
      if (response.data && response.data.data) {
        if (response.data.colors.logo_type) {
          setUserLogo(response.data.colors.logo_type);
        }
        setLayoutType(response.data.colors.page_type);
        setUserId(response.data.colors.user_id);
        setBgColor(response.data.colors.bg_color);
        setBgColorTwo(response.data.colors.bg_color_gradient);
        setFontColor(response.data.colors.font_color);
        setPreviewColor(response.data.colors.preview_font_color);
        response.data.data.map((element) => {
          if (element.type === "PRODUCT") {
            element.product["height"] = 545 / 3;
            if (element.product.face_four) {
              element.product["height"] = 545 / 4;
            }
            if (element.product.face_five) {
              element.product["height"] = 545 / 5;
            }
            if (element.product.face_six) {
              element.product["height"] = 545 / 6;
            }
            element.isVertical = true;
            if (element.sizes.length) {
              let firstSize = element.sizes[0].name.toLowerCase();
              let sizeNames = firstSize.split("x");
              if (sizeNames.length > 1) {
                if (
                  sizeNames[0].replace(/[^0-9\.]+/g, "") ==
                  sizeNames[1].replace(/[^0-9\.]+/g, "")
                ) {
                  element.isVertical = false;
                }
              }
            }
          }
        });
        console.log(response.data.data);
        setProducts(response.data.data);
      } else {
        setProducts([]);
      }
    } finally {
    }
  };

  const updateColors = async () => {
    if (!userId) {
      return;
    }
    try {
      toast.success("Colors saved.", {
        autoClose: 2000,
        position: "top-center",
      });
      await axios.post(API_URL.PRODUCT_UPDATE_COLORS, {
        user_id: userId,
        bg_color: bgColor,
        bg_color_gradient: bgColorTwo,
        font_color: fontColor,
        preview_font_color: previewColor,
        logo_type: userLogo,
      });
    } finally {
    }
  };

  const allowedFileTypes = ["image/jpeg", "image/jpg", "image/png"]; // Define allowed file types

  const onFileChange = (file) => {
    if (!file) {
      toast.error("No file selected.");
      fileInputRef.current.value = "";
      return;
    }

    if (!allowedFileTypes.includes(file.type)) {
      toast.error("Only JPEG, JPG, and PNG files are allowed.");
      fileInputRef.current.value = "";
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      toast.error("File size must be less than or equal to 2MB.");
      fileInputRef.current.value = "";
      return;
    }

    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setWithoutLogoBasd64(reader.result);
    };
    reader.onerror = (error) => {
      console.log("Error: ", error);
      toast.error("Failed to read the file.");
      fileInputRef.current.value = "";
    };
  };

  const userInfo = () => {
    axios.post(API_URL.LOGIN_USER, {}).then((res) => {
      if (res.data) {
        setIsAllowed(res.data.is_allowed);
      }
    });
  };

  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe && layoutType) {
      if (iframe) {
        iframe.addEventListener("load", () => {
          setTimeout(() => {
            setIsIFrameLoaded(true);
          }, 1500);
        });
      }
      return () => {
        if (iframe) {
          iframe.removeEventListener("load", setIsIFrameLoaded(true));
        }
      };
    }
  }, [iframeRef, layoutType]);

  useEffect(() => {
    setTimeout(() => {
      setIsIFrameLoaded(true);
    }, 10000);
    userInfo();
  }, []);

  useEffect(() => {
    if (ids) {
      setProductIds(ids.split(","));
    }
  }, [ids]);

  useEffect(() => {
    if (productIds.length > 0) {
      setWithoutLogoBasd64("");
      fetchProducts();
    }
  }, [productIds, withoutlogo]);

  useEffect(() => {
    if (layoutType === "Horizontal") {
      setPageSize(595);
    }
    if (layoutType === "Vertical") {
      setPageSize(842);
    }
  }, [layoutType]);

  return (
    <div className="d-flex">
      <div style={{ width: "25%" }}>
        <Tabs
          defaultActiveKey="colors"
          id="uncontrolled-tab-example"
          className=" mb-1"
        >
          <Tab eventKey="colors" title="Colors">
            <div className="row">
              <div className="col-md-11">
                <div className="form-group">
                  <label className={`form-label `}>Font Color</label>
                  <InputColor
                    className="w-100"
                    initialValue={fontColor}
                    onChange={(color) => {
                      if (color.hex && color.hex.length > 7) {
                        let result = color.hex.substr(0, 7);
                        setFontColor(result);
                      }
                    }}
                    placement="top"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-11">
                <div className="form-group">
                  <label className={`form-label `}>Preview Font Color</label>
                  <InputColor
                    className="w-100"
                    initialValue={previewColor}
                    onChange={(color) => {
                      if (color.hex && color.hex.length > 7) {
                        let result = color.hex.substr(0, 7);
                        setPreviewColor(result);
                      }
                    }}
                    placement="top"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-11">
                <div className="form-group">
                  <label className={`form-label `}>Background Color</label>
                  <InputColor
                    className="w-100"
                    initialValue={bgColor}
                    onChange={(color) => {
                      if (color.hex && color.hex.length > 7) {
                        let result = color.hex.substr(0, 7);
                        setBgColor(result);
                      }
                    }}
                    placement="top"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-11">
                <div className="form-group">
                  <label className={`form-label `}>
                    Background Gradient Color
                  </label>
                  <InputColor
                    className="w-100"
                    initialValue={bgColorTwo}
                    onChange={(color) => {
                      if (color.hex && color.hex.length > 7) {
                        let result = color.hex.substr(0, 7);
                        setBgColorTwo(result);
                      }
                    }}
                    placement="top"
                  />
                </div>
              </div>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                value={"LOGO"}
                checked={userLogo === "LOGO"}
                name="flexRadioDefault"
                id="flexRadioDefault1"
                onChange={(e) => setUserLogo(e.target.value)}
              />
              <label className="form-check-label" htmlFor="flexRadioDefault1">
                Original Logo
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                value={"DARKLOGO"}
                checked={userLogo === "DARKLOGO"}
                name="flexRadioDefault"
                id="flexRadioDefault2"
                onChange={(e) => setUserLogo(e.target.value)}
              />
              <label className="form-check-label" htmlFor="flexRadioDefault2">
                White Logo
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={withoutlogo}
                id="flexCheckDefault"
                onChange={(e) => {
                  setWithoutLogo(e.target.checked);
                  if (e.target.checked) {
                    setIsIFrameLoaded(false);
                  }
                }}
              />
              <label className="form-check-label" htmlFor="flexCheckDefault">
                Without Logo
              </label>
            </div>
            {withoutlogo && isAllowed && (
              <div className="col-lg-10 col-md-6 col-sm-12">
                <div className="form-group">
                  <input
                    type="file"
                    name="logo"
                    className="form-control"
                    id="logo"
                    ref={fileInputRef}
                    onChange={(event) => {
                      if (event.target.files && event.target.files[0]) {
                        onFileChange(event.target.files[0]);
                      } else {
                        toast.error("No file selected.");
                      }
                    }}
                  />
                </div>
              </div>
            )}
            {withoutlogo && isAllowed && (
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  value={"LEFTLOGO"}
                  checked={usersLogo === "LEFTLOGO"}
                  name="flexRadioDefaults"
                  id="flexRadioDefault3"
                  onChange={(e) => {
                    setUsersLogo(e.target.value) ;
                  }}
                />
                <label className="form-check-label" htmlFor="flexRadioDefault3">
                  Left
                </label>
              </div>
            )}
            {withoutlogo && isAllowed && (
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  value={"RIGHTLOGO"}
                  checked={usersLogo === "RIGHTLOGO"}
                  name="flexRadioDefaults"
                  id="flexRadioDefault4"
                  onChange={(e) => {
                    setUsersLogo(e.target.value);
                  }}
                />
                <label className="form-check-label" htmlFor="flexRadioDefault4">
                  Right
                </label>
              </div>
            )}
            {withoutlogo && isAllowed && (
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  value={"CENTERLOGO"}
                  checked={usersLogo === "CENTERLOGO"}
                  name="flexRadioDefaults"
                  id="flexRadioDefault5"
                  onChange={(e) => {
                    setUsersLogo(e.target.value);
                  }}
                />
                <label className="form-check-label" htmlFor="flexRadioDefault5">
                  Center
                </label>
              </div>
            )}

            <div className="row">
              <div className="col-md-11">
                <div className="form-group">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={updateColors}
                  >
                    Save Colors
                  </button>
                </div>
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
      <div style={{ width: "75%", position: "relative" }}>
        {!isIFrameLoaded ? (
          <div
            style={{
              width: "100%",
              background: "#00000094",
              height: "calc(100vh - 100px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "absolute",
              top: 0,
              left: 0,
            }}
          >
            <Loader color="#ffffff"></Loader>
          </div>
        ) : null}
        {layoutType && (
          <PDFViewer className="pdf-viewer-section" innerRef={iframeRef}>
            <Document title={fileName} file="somefile.pdf">
              {products.map((element, key) => {
                return (
                  <Page
                    size="A4"
                    orientation={
                      layoutType === "Horizontal" ? "landscape" : "portrait"
                    }
                    key={key}
                  >
                    {element.type === "START_PAGE" && (
                      <View style={styles.imageContainer}>
                        <Image
                          cache={false}
                          src={element.image}
                          style={{ height: pageSize }}
                        />
                          {withoutlogo &&
                          withoutlogoBasd64 &&
                          usersLogo === "LEFTLOGO" ? (
                            <view style={{position: "absolute",left:0,padding:"10"}}>
                            <Image
                              cache={false}
                              style={{
                                left:0,
                                maxWidth: 150,
                                maxHeight: 50,
                              }}
                              src={withoutlogoBasd64}
                            />
                          </view>
                          ) : null}
                          {withoutlogo &&
                          withoutlogoBasd64 &&
                          usersLogo === "CENTERLOGO" ? (
                            <view style={{position:"absolute",left:"40%",right:"30%",paddingTop:10}}>
                            <Image
                              cache={false}
                              style={{
                                maxWidth: 150,
                                maxHeight: 50,
                              }}
                              src={withoutlogoBasd64}
                            />
                            </view>
                          ) : null}
                          {withoutlogo &&
                          withoutlogoBasd64 &&
                          usersLogo === "RIGHTLOGO" ? (
                            <view style={{position: "absolute",right:0,padding:10}}>
                            <Image
                              cache={false}
                              style={{
                                maxWidth: 150,
                                maxHeight: 50,
                              }}
                              src={withoutlogoBasd64}
                            />
                            </view>
                          ) : null}
                      </View>
                    )}

                    {element.type === "SINGLE_PAGE" && (
                      <View style={styles.imageContainer}>
                        <Image
                          cache={false}
                          src={element.image}
                          style={{ height: pageSize }}
                        />
                          {withoutlogo &&
                          withoutlogoBasd64 &&
                          usersLogo === "LEFTLOGO" ? (
                            <view style={{position: "absolute",left:0,padding:"10"}}>
                            <Image
                              cache={false}
                              style={{
                                left:0,
                                maxWidth: 150,
                                maxHeight: 50,
                              }}
                              src={withoutlogoBasd64}
                            />
                          </view>
                          ) : null}
                          {withoutlogo &&
                          withoutlogoBasd64 &&
                          usersLogo === "CENTERLOGO" ? (
                            <view style={{position:"absolute",left:"40%",right:"30%",paddingTop:10}}>
                            <Image
                              cache={false}
                              style={{
                                maxWidth: 150,
                                maxHeight: 50,
                              }}
                              src={withoutlogoBasd64}
                            />
                            </view>
                          ) : null}
                          {withoutlogo &&
                          withoutlogoBasd64 &&
                          usersLogo === "RIGHTLOGO" ? (
                            <view style={{position: "absolute",right:0,padding:10}}>
                            <Image
                              cache={false}
                              style={{
                                maxWidth: 150,
                                maxHeight: 50,
                              }}
                              src={withoutlogoBasd64}
                            />
                            </view>
                          ) : null}
                      </View>
                    )}
                    {element.type === "PRODUCT" && (
                      <>
                        {layoutType === "Horizontal" && (
                          <HorizontalProduct
                            element={element}
                            pageSize={pageSize}
                            bgColor={bgColor}
                            bgColorTwo={bgColorTwo}
                            fontColor={fontColor}
                            userLogo={userLogo}
                            previewColor={previewColor}
                            withoutlogo={withoutlogo}
                            withoutlogoBasd64={withoutlogoBasd64}
                          />
                        )}
                        {layoutType === "Horizontal" &&
                          element.product.preview &&
                          !element.is_hide_preview && (
                            <View style={styles.previewImage}>
                              <Image
                                cache={false}
                                src={element.product.preview}
                                style={{ width: "100%", maxHeight: 555 }}
                              />
                              <View style={styles.previewname}>
                                <View>
                                  <Text style={{ fontFamily: "UniversoBold" }}>
                                    {element.product.name}
                                  </Text>
                                </View>
                                <View style={styles.previewBoxDetail}>
                                  {element.sizes.length > 0 &&
                                    element.sizes.map((size, key) => {
                                      return (
                                        <View
                                          key={key}
                                          style={styles.previewSizeBox}
                                        >
                                          <Text
                                            style={{
                                              ...styles.previewsize,
                                              fontFamily: "NexaBold",
                                            }}
                                          >
                                            {size.name}
                                          </Text>
                                          <Text
                                            style={{
                                              ...styles.previewsize,
                                              fontFamily: "NexaLight",
                                            }}
                                          >
                                            {size.unit}
                                          </Text>
                                          <Text>
                                            {element.sizes.length - 1 !==
                                              key && (
                                              <Text
                                                style={{ color: previewColor }}
                                              >
                                                &nbsp;|&nbsp;
                                              </Text>
                                            )}
                                          </Text>
                                        </View>
                                      );
                                    })}
                                </View>
                              </View>
                            </View>
                          )}
                        {layoutType === "Vertical" && (
                          <VerticalProduct
                            element={element}
                            bgColor={bgColor}
                            pageSize={pageSize}
                            bgColorTwo={bgColorTwo}
                            userLogo={userLogo}
                            fontColor={fontColor}
                            previewColor={previewColor}
                            withoutlogo={withoutlogo}
                            withoutlogoBasd64={withoutlogoBasd64}
                          />
                        )}
                      </>
                    )}
                    {element.type === "END_PAGE" && (
                      <View style={styles.imageContainer}>
                        <Image
                          cache={false}
                          src={element.image}
                          style={{ height: pageSize }}
                        />
                          {withoutlogo &&
                          withoutlogoBasd64 &&
                          usersLogo === "LEFTLOGO" ? (
                            <view style={{position: "absolute",left:0,padding:"10"}}>
                            <Image
                              cache={false}
                              style={{
                                left:0,
                                maxWidth: 150,
                                maxHeight: 50,
                              }}
                              src={withoutlogoBasd64}
                            />
                          </view>
                          ) : null}
                          {withoutlogo &&
                          withoutlogoBasd64 &&
                          usersLogo === "CENTERLOGO" ? (
                            <view style={{position:"absolute",left:"40%",right:"30%",paddingTop:10}}>
                            <Image
                              cache={false}
                              style={{
                                maxWidth: 150,
                                maxHeight: 50,
                              }}
                              src={withoutlogoBasd64}
                            />
                            </view>
                          ) : null}
                          {withoutlogo &&
                          withoutlogoBasd64 &&
                          usersLogo === "RIGHTLOGO" ? (
                            <view style={{position: "absolute",right:0,padding:10}}>
                            <Image
                              cache={false}
                              style={{
                                maxWidth: 150,
                                maxHeight: 50,
                              }}
                              src={withoutlogoBasd64}
                            />
                            </view>
                          ) : null}
                      </View>
                    )}
                  </Page>
                );
              })}
            </Document>
          </PDFViewer>
        )}
      </div>
    </div>
  );
};
export default PdfView;
